import gql from "graphql-tag";

export const surveyListQuery = gql`
  query surveyList($orderBy: OrderBy, $page: Int, $perPage: Int) {
    surveyList(orderBy: $orderBy, page: $page, first: $perPage) {
      data {
        id
        title
        startsAt
        endsAt
        maxShows
      }
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
    }
  }
`;
